// extracted by mini-css-extract-plugin
module.exports = {"behaviorContainer":"guest-details-profile_behaviorContainer__3dNpW"};